import { jsx as o, Fragment as l, jsxs as m } from "react/jsx-runtime";
import { forwardRef as i } from "react";
import { getComponent as a, getEnableFallbackComponent as c, getCustomFallbackComponent as d } from "./index2.mjs";
const s = i(
  ({ blok: e, ...t }, p) => {
    if (!e)
      return console.error(
        "Please provide a 'blok' property to the StoryblokComponent"
      ), /* @__PURE__ */ o("div", { children: "Please provide a blok property to the StoryblokComponent" });
    const n = a(e.component);
    if (n)
      return /* @__PURE__ */ o(n, { ref: p, blok: e, ...t });
    if (c()) {
      const r = d();
      return r ? /* @__PURE__ */ o(r, { blok: e, ...t }) : /* @__PURE__ */ o(l, { children: /* @__PURE__ */ m("p", { children: [
        "Component could not be found for blok",
        " ",
        /* @__PURE__ */ o("strong", { children: e.component }),
        "! Is it configured correctly?"
      ] }) });
    }
    return /* @__PURE__ */ o("div", {});
  }
);
s.displayName = "StoryblokComponent";
export {
  s as default
};
